module.exports = __webpack_public_path__ + "static/media/logo.62ef038f.png";